import request from "./request";
// import http from "./http";
// import qs from "qs";

//邮箱注册
export function register(data) {
    return request({
        url: "/common/register",
        method: "post",
        data: data,
    });
}

//邮箱密码登录
export function emailLogin(data) {
    return request({
        url: "/common/emailLogin",
        method: "post",
        data: data,
    });
}

//发送验证码
export function sendEmail(data) {
    return request({
        url: "/common/sendEmail",
        method: "post",
        data: data,
    });
}

//邮箱验证码登录
export function emailVerifyLogin(data) {
    return request({
        url: "/common/emailVerifyLogin",
        method: "post",
        data: data,
    });
}

//处理重置密码
export function emailResetPassword(data) {
    return request({
        url: "/common/emailResetPassword",
        method: "post",
        data: data,
    });
}

//修改密码
export function changePassword(data) {
    return request({
        url: "/user/changePassword",
        method: "post",
        data: data,
    });
}

//获取用户数据信息
export function userInfo(params) {
    return request({
        url: "/user/userInfo",
        method: "post",
        params: "",
    });
}

//编辑用户信息
export function editUserInfo(data) {
    return request({
        url: "/user/editUserInfo",
        method: "post",
        data: data,
    });
}

//删除账号（接口暂时关闭中）
export function deleteUser(data) {
    //请注意 logout 看上去是退出登录 但是在后端接口中是删除账号
    return request({
        url: "/user/logout",
        method: "post",
        data: '',
    });
}
//获取文章内容
export function articleDetail(params) {
    return request({
        url: "/common/articleDetail",
        method: "get",
        params: params,
    });
}

//其实，也不一定就是params，也可以是 query 还有 data 的呀！
//params是添加到url的请求字符串中的，用于get请求。会将参数加到 url后面。所以，传递的都是字符串。无法传递参数中含有json格式的数据
//而data是添加到请求体（body）中的， 用于post请求。添加到请求体（body）中，json 格式也是可以的。
